import { render } from "./SafetyLawBackground.vue?vue&type=template&id=82266b92&scoped=true"
import script from "./SafetyLawBackground.vue?vue&type=script&lang=js"
export * from "./SafetyLawBackground.vue?vue&type=script&lang=js"

import "./SafetyLawBackground.vue?vue&type=style&index=0&id=82266b92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-82266b92"

export default script